export { supportsPassiveEvents } from 'detect-it';
//# sourceMappingURL=detect-passive-events.esm.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/detect-passive-events/dist/detect-passive-events.esm.js
// module id = 508
// module chunks = 0